/**
 * @fileOverview .modules/common/core/httpInterceptor.js
 * @description intercepts http requests and responses.
 */
(function(angular) {

	'use strict';

	var tokenCheckRunning = null;
	angular.module('skPlatformBootLoader')
		.factory('authHttpResponseInterceptor', ['$rootScope', '$q', '$localStorage', '$location',
			'$timeout', "$uuid", "$templateCache",
			function($rootScope, $q, $localStorage, $location, $timeout, $uuid, $templateCache) {
				var $ = angular.element;
				var loggerService;

				var stripUrl = function(url){
					url = url || "";
					var idx = url.indexOf("?");
					if(idx >= 0){
						url = url.substring(0, idx);
					}
					return url;
				};
				var logger = null;
				var logIt = function(message, params, level){
					try{
						if(!logger){
							var injector = $("body").injector();
							if(injector){
								logger = injector.get("msx.loggerService");
							}
						}
						if(logger){
							if(params){
								logger[level || "log"](message, params);
							}else{
								logger[level || "log"](message);
							}
						}
					}catch(ex){}
				};

				var logSpecificErrors = function(resp){
					var url;
					if(resp){
						var traceId = resp.config && resp.config.headers ? resp.config.headers["X-B3-TraceId"] || "" : "";
						if(resp.status === 504){
							url = resp.config ? resp.config.url || "UNKNOWN" : "UNKNOWN";
							logIt("The server timed out.  Obtained a Gateway timeout error (504) from the server.  Message: " + resp.statusText + " URL called: [" + url + "]" + (traceId ? "  TraceId: [" + traceId + "]" : ""), null, "error");
						}
						if(resp.status === -1){
							url = resp.config ? resp.config.url || "UNKNOWN" : "UNKNOWN";
							logIt("The server returned an invalid CORS response.  Message: " + resp.statusText + " URL called: [" + url + "]" + (traceId ? "  TraceId: [" + traceId + "]" : ""), null, "error");
						}
					}
				};

				var generateErrorAlert = function(alertObj, resp){
					try{
						var injector = $("body").injector();
						if(injector){
							var alertService = injector.get("msx.alertService");
							if(alertService){
								alertObj.traceid = alertObj.traceid || alertService.extractTraceID(resp || {});
								alertService.danger(alertObj);
							}
						}
					}catch(ex){}
				};

				var responseHandler = function(response, headers) {
					var def = $q.defer();
					var url = response && response.config && response.config.url ? response.config.url : "";
					var retryAttempt = response && response.config && response.config.retry ? true : false;
					var skipCloseout = response && response.config && response.config.skipCloseout ? true : false;
					if (response.status === 401 && url.indexOf("grant_type=refresh_token") == -1 && url.indexOf("api/v1/pwdpolicy/userId/") == -1 && !retryAttempt && !skipCloseout) {
						logIt("401 recieved.  The token needs to be checked for invalidation and expiry, and refreshed if possible.");
						var msxInfo = null;
						try{
							msxInfo = $("body").injector().get("msx.platform.msxInfo");
						}catch(ex){}												
						// We need to check the life of the token.  Should it still be alive,
						// and if so, we should regenerate a new token
						var closeOutUser = function(){
							//clear pollers on timeout
							if ($localStorage.servicePoller) {
								clearInterval($localStorage.servicePoller);
							}
							if ($localStorage.resourcePoller) {
								clearInterval($localStorage.resourcePoller);
							}
							if ($rootScope.sessionPoller) {
								clearInterval($rootScope.sessionPoller);
								delete $rootScope.sessionPoller;
							}
							if ($localStorage.loggedout) {
								setTimeout(function() {
									$localStorage.$reset();
								}, 1000);
								return false;
							}

							// We've authed out, so clear the tokens and throw out to the login 'page'.
							$localStorage.Authorization = null;
							$localStorage.timedout = true;
							var SAML_RETURN_URL = window["SAML_RETURN_URL"];
							var NON_SAML_LOGOUT_URL = window["NON_SAML_LOGOUT_URL"];
							if(NON_SAML_LOGOUT_URL && NON_SAML_LOGOUT_URL.indexOf("@@") === 0){
								NON_SAML_LOGOUT_URL = null;
							}
							if(SAML_RETURN_URL && SAML_RETURN_URL.indexOf("@@") === 0){
								SAML_RETURN_URL = null;
							}
							if(SAML_RETURN_URL || NON_SAML_LOGOUT_URL){
								if ($localStorage.isSAMLLogin == "true") {
									$localStorage.$reset();
									window.location = SAML_RETURN_URL;
								} else {
									$localStorage.$reset();
									window.location.href = NON_SAML_LOGOUT_URL;
								}
							}else{
								$localStorage.timedout = true;
								$localStorage.loggedout = true;
								$timeout(function(){
									$location.path('/timeout');
								}, 10);
							}
						};

						var cTime = new Date().getTime();
						var expTime = $localStorage.tokenExpiry;

						if(expTime > cTime){
							// It should still be alive, we should try to refresh it, instead of just kicking the user out
							// immediately.
							var refreshTheToken = function() {
								var $http = $("body").injector().get("$http");
								var vmsActivityMonitor = null;
								try{
									vmsActivityMonitor = $("body").injector().get("vmsActivityMonitor");
								}catch(ex){}

								var refreshFunc = function() {
									var reauthComplete = $q.defer();
									$http({
										method: 'POST',
										url: msxInfo.getAPIGateway() + "/idm/v2/token?client_id=nfv-client&grant_type=refresh_token&refresh_token=" + $localStorage.refreshToken,
										headers: {},
										contentType: "application/json; charset=utf-8",
										dataType: 'json'
									}).then(function(resp) {
										var data = resp.data;
										$localStorage.Authorization = data.access_token;
										$http.defaults.headers.common.Authorization = "Bearer " + data.access_token;
										$localStorage.refreshToken = data.refresh_token;
										logIt("Obtained a new authentication token.");
										if(!isNaN(data.expires_in)){
											$localStorage.tokenExpiry = (new Date().setTime(new Date().getTime() + (parseInt(data.expires_in, 10) * 1000)));
										}
										if(vmsActivityMonitor){
											vmsActivityMonitor.updateActivity();
										}
										$timeout(function(){
											reauthComplete.resolve(true);
										}, 0);
									}, function(resp) {
										var msg = "";
										if (resp.status === 400) {
											msg = "cisco.idm.security.delete.tenant.refresh.token.failure";
										} else {
											msg = resp.data ? resp.data.message || "cisco.idm.security.delete.tenant.refresh.token.failure" : "cisco.idm.security.delete.tenant.refresh.token.failure";
										}
										generateErrorAlert({
											'message': msg,
											'title': "cisco.idm.security.delete.tenant.refresh.token.failure.title",
											'timeout': '30'
										}, resp);
										$timeout(function(){
											reauthComplete.reject(new Error(msg));
										}, 0);
									});
									return reauthComplete.promise;
								};
								var dd = $q.defer();
								$timeout(function(){
									var runCheck = function(){
										var d = refreshFunc();
										tokenCheckRunning = d;
										d.then(function(){
											dd.resolve(true);
											tokenCheckRunning = null;
										}, function(err){
											dd.reject(err);
											tokenCheckRunning = null;
										});
									};
									if(tokenCheckRunning){
										tokenCheckRunning["finally"](runCheck);
									}else{
										runCheck();
									}
								}, 0);
								return dd.promise;
							};
							// We should check if the token is valid before we call refresh, if it's still valid, than the 401
							// error is correct and we don't even need to try and refresh it.
							try{
								var $http = $("body").injector().get("$http");
								var traceId = response.config && response.config.headers ? response.config.headers["X-B3-TraceId"] || "" : "";

								if($http){
									$http({
										method: "GET",
										url: msxInfo.getAPIGateway() + "/idm/api/v1/isTokenValid",
										retry: true
									}).then(function(resp){
										// The token was valid, we need to return the response.
										logIt("Token valid.  Previous response was valid, returning it to caller.   Request returned code: [" + response.status + "]." + (traceId ? "  TraceId: [" + traceId + "]" : ""));
										if(response.status >= 300){
											logSpecificErrors(response);
											def.reject(response);
										}else{
											def.resolve(response);
										}
									},function(err){
										logIt("The token was reported invalid, attempting to refresh it with a new one." + (traceId ? "  TraceId: [" + traceId + "]" : ""));
										refreshTheToken().then(function(){
											response.config.retry = true;
											$http(response.config).then(function(resp){
												def.resolve(resp);
											}, function(errResp){
												logSpecificErrors(response);
												def.reject(errResp);
											});
										},
										function(){
											$timeout(function(){
												// Couldn't refresh, so expire the user out,
												// after 5 seconds so the user can relog in.
												closeOutUser();
											}, 5000);
											def.resolve(response);
										});
									});
								}else{
									// The token was valid, we need to return the response.
									if(response.status >= 300){
										logSpecificErrors(response);
										def.reject(response);
									}else{
										def.resolve(response);
									}
								}
							}catch(ex){
								logIt("Unable to get $http, ignoring token refresh call.");
								// The token was valid, we need to return the response.
								if(response.status >= 300){
									logSpecificErrors(response);
									def.reject(response);
								}else{
									def.resolve(response);
								}
							}
						}else{
								if(skipCloseout){
								logSpecificErrors(response);
								def.reject(response);
							}else{
								closeOutUser();
							}
						}
					}else{
						if(response.status >= 300 || response.status === -1){
							logSpecificErrors(response);
							def.reject(response);
						}else{
							def.resolve(response);
						}
					}
					return def.promise;
				};

				return {
					response: responseHandler,
					responseError: responseHandler,
					request: function(request) {
						var def = $q.defer();
						var skipTokenCheck = false;
						if (request.method === 'POST' || request.method === 'PUT') {
							var action = (request && request.data != null && request.data.action != null) ? request.data.action : "";
							if (action !== "" && (action === 'orderOffer' || action === 'updateSubscription')) {
								request.data.payload.subscriptionDetail.serviceInstanceDetail.serviceExtensions = $localStorage.customTemplatePayload;
							}
						}
						var headers = request.headers || {};
						var uuid = $uuid().replaceAll("-", "");
						uuid = uuid.substring(0,16);
						headers["X-B3-TraceId"] = uuid;
						headers["X-B3-SpanId"] = uuid;
						request.headers = headers;
						var logRequest = true;
						if(request.method.toLowerCase() === "get"){
							if($templateCache.get(request.url) ||
								_.endsWith(request.url, "isTokenValid") ||
								_.endsWith(request.url, "notifications/counts") ||
								(request.url || "").indexOf("grant_type=refresh_token") >= 0){
								logRequest = false;
							}
						}
						if(logRequest){
							var cleanUrl = stripUrl(request.url);
							if(cleanUrl){
								logIt((request.method || "GET") + ": [" + cleanUrl + "] - TraceID: [" + uuid + "]");
							}
						}
						def.resolve(request);
						return def.promise;
					}
				};
			}
		]);
})(window.angular);
